import { RenderingProps, GoldBarParams } from '@/shared/shared.types';
import { LinkField, ComponentParams } from '@sitecore-jss/sitecore-jss-nextjs';

export type C03HeadlineCTAProps = RenderingProps<C03HeadlineCTAFields, C03HeadlineCTAParams>;

export type C03HeadlineCTAFields = {
  CTA?: LinkField;
};

export type C03HeadlineCTAParams = { params?: ComponentParams } & GoldBarParams;
